(function() {
  'use strict';
  
  document.addEventListener("DOMContentLoaded", function () {
    function updateReviewText() {
      // Select the element containing the text
      let reviewButton = document.querySelector(".mobile-filters-footer-btn .footer-text");
      
      if (reviewButton && reviewButton.textContent.match(/Show \d+ Reviews/)) {
        reviewButton.textContent = "Show More Reviews";
      }
    }

    // Run the function initially in case the element is already loaded
    updateReviewText();

    // Use MutationObserver to detect changes in the DOM (useful for dynamically loaded content)
    const observer = new MutationObserver(updateReviewText);
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
